import React from 'react'
import { View } from 'react-native'
import {
  BG_STYLES,
  BUTTON_STATUS,
  Button,
  BUTTON_TYPE,
  SIZE,
  TEXT_STYLES,
} from '@dehaat/dds'
import { RoleType } from 'app/constants/request'
import { useTranslation } from 'react-i18next'

type Props = {
  styles: any
  isMultiSelectEnabled: boolean
  statusFilter: string
  pendingStatusFilter: string
  roleType?: string
  selectedRequestIds: number[]
  onOpenReject: () => void
  onTriggerApprove: () => void
}

const DemoBulkActionBar = ({
  styles,
  isMultiSelectEnabled,
  statusFilter,
  pendingStatusFilter,
  roleType,
  selectedRequestIds,
  onOpenReject,
  onTriggerApprove,
}: Props) => {
  const { t } = useTranslation()
  const hasSelection = selectedRequestIds.length > 0

  if (
    !isMultiSelectEnabled ||
    statusFilter !== pendingStatusFilter ||
    (roleType !== RoleType.L1 && roleType !== RoleType.L2)
  ) {
    return null
  }

  return (
    <View style={styles.bulkActionWrapper}>
      <Button
        buttonStyle={[
          styles.bulkActionBtn,
          hasSelection ? BG_STYLES.bgError100 : BG_STYLES.bgNeutral20,
        ]}
        onClick={onOpenReject}
        type={BUTTON_TYPE.PRIMARY}
        text={t('reject')}
        size={SIZE.small}
        status={hasSelection ? BUTTON_STATUS.ACTIVE : BUTTON_STATUS.DISABLED}
        textStyle={[
          hasSelection ? TEXT_STYLES.textNeutral00 : TEXT_STYLES.textNeutral70,
        ]}
      />
      <Button
        buttonStyle={[
          styles.bulkActionBtn,
          hasSelection ? BG_STYLES.bgPrimary100 : BG_STYLES.bgNeutral20,
        ]}
        onClick={onTriggerApprove}
        type={BUTTON_TYPE.PRIMARY}
        text={t('approve')}
        size={SIZE.small}
        status={hasSelection ? BUTTON_STATUS.ACTIVE : BUTTON_STATUS.DISABLED}
        textStyle={[
          hasSelection ? TEXT_STYLES.textNeutral00 : TEXT_STYLES.textNeutral70,
        ]}
      />
    </View>
  )
}

export default DemoBulkActionBar
